// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DiagnosticsController {
   $routeParams: any
   $scope: any
   diagnosticsService: any
   constructor($scope: any, diagnosticsService: any, $routeParams: any) {

      this.getDiagnostics = this.getDiagnostics.bind(this)
      this.setDiagnostics = this.setDiagnostics.bind(this)
      this.$scope = $scope
      this.diagnosticsService = diagnosticsService
      this.$routeParams = $routeParams
      if (!this.$scope.diagnostics) { this.$scope.diagnostics = false }
      if (!this.$scope.parentKey) { this.$scope.parentKey = (_.isString(this.$routeParams.diagnostic) && this.$routeParams.diagnostic) || '' }
      if (!this.$scope.libraryCode) { this.$scope.libraryCode = this.$routeParams.library_code || '' }
      if (!this.$scope.key) { this.$scope.key = ((this.$routeParams.diagnostic != null) && _.isString(this.$routeParams.diagnostic) ? this.$routeParams.diagnostic.replace(/\./g, '-') : undefined) || 'Maverick Diagnostics' }

      this.$scope.getDiagnostics = this.getDiagnostics
      this.$scope.loadingDiagnostics = false
      if (!this.$scope.diagnostics) { this.getDiagnostics() }
   }

   getDiagnostics() {
      this.$scope.loadingDiagnostics = true
      return this.diagnosticsService.get(this.$scope.parentKey, this.$scope.libraryCode).then(this.setDiagnostics)
   }

   setDiagnostics(data: any) {
      if (!this.$scope.diagnostics) {
         this.$scope.diagnostics = data
      } else {
         angular.extend(this.$scope.diagnostics, data)
      }
      return this.$scope.loadingDiagnostics = false
   }
}

DiagnosticsController.$inject = ['$scope', 'diagnosticsService', '$routeParams']

angular.module('summonApp.controllers')
   .controller('DiagnosticsCtrl', DiagnosticsController)
